// import external dependencies
window.$ = window.jQuery = require('jquery');

// Import everything from autoload
import './autoload/_smartresize';

// import local dependencies
import Router from './util/Router';
import common from './client/routes/common';
import vibeTeamtailorFrontendTerritoryStudioJobSinglePage from './client/routes/job-single';
import vibeTeamtailorFrontendTerritoryStudioJobSingleApplication from './client/routes/job-application';

/** Populate Router instance with DOM routes */
const routes = new Router({
	// All pages
	common,
	vibeTeamtailorFrontendTerritoryStudioJobSinglePage,
	vibeTeamtailorFrontendTerritoryStudioJobSingleApplication
});

// Load Events
jQuery(document).ready(() => routes.loadEvents());
